/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EnrollmentPreviewCandidateBucket = typeof EnrollmentPreviewCandidateBucket[keyof typeof EnrollmentPreviewCandidateBucket];


export const EnrollmentPreviewCandidateBucket = {
  no_issue: 'no_issue',
  warning: 'warning',
  fix: 'fix',
} as const;
